<template>
  <div class="col-12">
    <Header
      ref="tab"
      :page="currentTabHeaderInfo"
      :signatureTabIsEnable="signatureTabIsEnable"
      :showSignaturesTab="showSignaturesTab"
      @reRender="reRender()"
      @saveTab="saveTab($event)"
      @refresh-digital-signature="(event) => refreshDigitalSignature(event)"
      @goToTab="setActive"
      @updateImpedimentInfo="updateImpedimentInfo"
    />
    <CompactMenu
      v-if="showCompactTabs"
      :items="this.visibleTabs(tabs)"
      :tab-id="activeTab"
      @set-active-tab="setCompactActiveTab"
    />
    <div ref="subMenuEl" class="Sub-menu no-margin-bottom">
      <div
        class="shadow-bottom"
        :class="{ 'tabs-measure-only': showCompactTabs }"
      >
        <ul
          ref="tabListEl"
          class="tab-list nav nav-pills mb-3 mt-4"
          role="tablist"
        >
          <li
            v-for="item in this.visibleTabs(tabs)"
            :key="item.Id"
            class="nav-item-Sub-menu text-center"
            :class="
              isPs
                ? `nav-item-Sub-menups ${widthClass} ${item.class}`
                : `${widthClass} ${item.class} `
            "
          >
            <a
              class="nav-link no-margin-left"
              :class="{ active: isActive(item.Name) }"
              href="#tab-i"
              role="tab"
              aria-selected="true"
              aria-controls="tab-i"
              @click.prevent="setActive(item.Id)"
            >
              {{ item.Caption }}
              <i
                v-if="isErrorTab[item.Id]"
                class="fas fa-exclamation-triangle"
              />
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="tab-content">
      <keep-alive>
        <component
          :is="activeTab"
          ref="currenTab"
          v-bind="currentProperties"
          @change-tab="activeTab = $event"
          @refresh-digital-signature="refreshDigitalSignature()"
        />
      </keep-alive>
    </div>
  </div>
</template>

<style scoped src="@/assets/css/pei/parte-k.css"></style>
<script>
import store from '@/store/index';
import header from './tabs/TabHeader';
import Tab1 from './tabs/Tab1';
import Tab2 from './tabs/Tab2';
import Tab3 from './tabs/Tab3';
import Tab4 from './tabs/Tab4';
import Tab5 from './tabs/Tab5';
import Tab6 from './tabs/Tab6';
import Tab7 from './tabs/Tab7';
import Tab8 from './tabs/Tab8';
import Tab9 from './tabs/Tab9';
import Tab10 from './tabs/Tab10';
import Tab11 from './tabs/Tab11';
import peiStatuses from '@/utils/constants/pei/peiStatus';
import { CompactMenu } from './components';
import signatures from '@/services/signatures';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
import generalService from '@/services/pei/general';

const TAB2_ID = 'Tab2';
const PATH_NAME_ADD_EVALUATION = 'student-evaluation-history-add';

const PARAM_IsEnablePeiSignatureCompuFiles = 'IsEnablePeiSignatureCompuFiles';
const PARAM_IsEnablePeiSignaturePeiSignedFiles =
  'IsEnablePeiSignaturePeiSignedFiles';
const PARAM_ActiveEducationalCompensatoryService =
  'ActiveEducationalCompensatoryService';

export default {
  components: {
    Header: header,
    Tab1: Tab1,
    Tab2: Tab2,
    Tab3: Tab3,
    Tab4: Tab4,
    Tab5: Tab5,
    Tab6: Tab6,
    Tab7: Tab7,
    Tab8: Tab8,
    Tab9: Tab9,
    Tab10: Tab10,
    Tab11: Tab11,
    CompactMenu,
  },
  props: {
    previousPath: {
      type: Object,
      require: true,
      default: () => {},
    },
  },
  data() {
    return {
      peiQuantity: 0,
      activeTab: 'Tab1',
      isPs: false,
      isPsc: false,
      peiStatus: 0,
      tabs: [
        {
          Id: 'Tab1',
          Name: 'Tab1',
          Caption: 'I',
          page: {
            tabIndex: 1,
            icon: 'fas fa-user-edit orange-icon fa-lg',
            title: 'I. Información del Estudiante',
            routes: ['Inicio', 'PEI', 'I. Información del Estudiante'],
            tooltip: 'Información del Estudiante',
          },
        },
        {
          Id: TAB2_ID,
          Name: TAB2_ID,
          Caption: 'II',
          page: {
            tabIndex: 2,
            icon: 'fas fa-user-edit orange-icon fa-lg',
            title: 'II. Información de Evaluaciones Realizadas',
            routes: [
              'Inicio',
              'PEI',
              'II. Información de Evaluaciones Realizadas',
            ],
            tooltip: 'II. Información de Evaluaciones Realizadas',
          },
        },
        {
          Id: 'Tab3',
          Name: 'Tab3',
          Caption: 'III',
          page: {
            tabIndex: 3,
            icon: 'fas fa-user-edit orange-icon fa-lg',
            title: 'III. Descripción del Funcionamiento del Estudiante',
            routes: [
              'Inicio',
              'PEI',
              'Descripción del Funcionamiento del Estudiante',
            ],
            tooltip: 'III. Descripción del Funcionamiento del Estudiante',
          },
        },
        {
          Id: 'Tab4',
          Name: 'Tab4',
          Caption: 'IV-V',
          page: {
            tabIndex: 4,
            icon: 'fas fa-user-edit orange-icon fa-lg',
            title: 'IV-V. Programa de Servicio',
            routes: ['Inicio', 'PEI', 'Programa de Servicio'],
            tooltip:
              'IV. Áreas que se desarrollarán en este PEI | V. Programa de servicios',
          },
        },
        {
          Id: 'Tab5',
          Name: 'Tab5',
          Caption: 'VI(A)-VI(E)',
          page: {
            tabIndex: 5,
            icon: 'fas fa-user-edit orange-icon fa-lg',
            title: 'VI. Otras Consideraciones y Servicios',
            routes: ['Inicio', 'PEI', 'Informacion'],
            tooltip: 'I. Información del Estudiante',
          },
        },
        {
          Id: 'Tab6',
          Name: 'Tab6',
          Caption: 'VI(F)-VI(J)',
          page: {
            tabIndex: 6,
            icon: 'fas fa-user-edit orange-icon fa-lg',
            title: 'VI. Otras consideraciones y servicios (continuación)',
            routes: ['Inicio', 'PEI', 'Informacion'],
            tooltip: 'Información del Estudiante',
          },
        },
        {
          Id: 'Tab7',
          Name: 'Tab7',
          Caption: 'VI(K)-VII',
          page: {
            tabIndex: 7,
            icon: 'fas fa-user-edit orange-icon fa-lg',
            title: 'VI. Otras consideraciones y servicios (continuación)',
            routes: ['Inicio', 'PEI', 'VI(K)-VII Año Escolar Extendido'],
            tooltip: 'VI(K)-VII Año Escolar Extendido',
          },
        },
        {
          Id: 'Tab8',
          Name: 'Tab8',
          Caption: 'VIII',
          page: {
            tabIndex: 8,
            icon: 'fas fa-user-edit orange-icon fa-lg',
            title: 'VIII. Análisis de Alternativa de Ubicación y Servicios',
            routes: ['Inicio', 'PEI', 'Informacion'],
            tooltip: 'Información del Estudiante',
          },
        },
        {
          Id: 'Tab9',
          Name: 'Tab9',
          Caption: 'IX-XIII',
          page: {
            tabIndex: 9,
            icon: 'fas fa-user-edit',
            title:
              'IX-XIII. Participación de la familia y otras agencias y firmas',
            routes: [
              'Inicio',
              'PEI',
              'Participación de la familia y otras agencias y firmas',
            ],
            tooltip: 'Participación de la familia y otras agencias y firmas',
          },
        },
        {
          Id: 'Tab10',
          Name: 'Tab10',
          Caption: 'Firma',
          page: {
            tabIndex: 10,
            icon: 'fas fa-user-edit',
            title: 'Proceso de Firma',
            routes: ['Inicio', 'PEI', 'Firma'],
            tooltip: 'Firma',
          },
        },
        {
          Id: 'Tab11',
          Name: 'Tab11',
          Caption: 'Serv. Compensatorios',
          class: 'compensatory-tab',
          page: {
            tabIndex: 11,
            icon: 'fas fa-user-edit orange-icon fa-lg',
            title: 'XIV. Servicios Compensatorios',
            routes: ['Inicio', 'PEI', 'Programa de Servicio'],
            tooltip: 'Servicios Compensatorios',
          },
        },
      ],
      Tabs: {
        Name: 'PEI Tab',
        Tab1Tab: {
          Name: 'Tab I',
        },
        Tab2Tab: {
          Name: 'Tab II',
        },
        Tab3Tab: {
          Name: 'Tab III',
        },
        Tab4Tab: {
          Name: 'Tab IV',
        },
        Tab5Tab: {
          Name: 'Tab V',
        },
        Tab6Tab: {
          Name: 'Tab VI',
        },
        Tab7Tab: {
          Name: 'Tab VII',
        },
        Tab8Tab: {
          Name: 'Tab VIII',
        },
        Tab9Tab: {
          Name: 'Tab IX',
        },
        Tab10Tab: {
          Name: 'Tab X',
        },
        Tab11Tab: {
          Name: 'Tab XIV',
        },
      },
      peiId: store.getters.SelectedPei,
      ValidationTriggered: store.getters.getPeiValidationTriggered,
      signatureTabIsEnable: false,
      activeEducationalCompensatoryService: false,
      // true cuando la fila de pestañas (ancho fijo/porcentual por pestaña,
      // ver parte-k.css) no cabe en el ancho real disponible y Bootstrap
      // (nav-pills = flex-wrap:wrap) la manda a una segunda fila -- se mide
      // de verdad (ver checkTabsOverflow) en vez de asumirlo por isMobile.
      tabsOverflow: false,
    };
  },
  async mounted() {
    await this.getSignatureTabIsEnable();
    await this.initSignatureFlags();
    const { tab } = this.$root.$route.query;
    if (tab) {
      this.activeTab = tab;
    }
    this.verifyPreviousPath();
    await this.getPeiQuantity();
    // Manejar query params iniciales si existen
    this.handleQueryParams();
    this.observeTabsWidth();
  },
  beforeDestroy() {
    if (this._tabsResizeObserver) {
      this._tabsResizeObserver.disconnect();
      this._tabsResizeObserver = null;
    }
  },
  watch: {
    '$route.query'(newQuery, oldQuery) {
      // Detectar cuando cambian los query params
      this.handleQueryParams(newQuery);
    },
  },
  computed: {
    currentProperties() {
      return {
        Info: this.Tabs[this.activeTab + 'Tab'],
      };
    },
    widthClass() {
      return this.activeEducationalCompensatoryService
        ? 'nav-item-Sub-menu-alt'
        : '';
    },
    currentTabHeaderInfo() {
      const currentTab = this.tabs.find((t) => t.Id === this.activeTab);
      return currentTab.page;
    },
    isErrorTab() {
      let validation = store.getters.getPeiValidationTriggered;
      if (validation.tabValidation === undefined)
        return {
          Tab1: false,
          Tab2: false,
          Tab3: false,
          Tab4: false,
          Tab5: false,
          Tab6: false,
          Tab7: false,
          Tab8: false,
          Tab9: false,
          Tab11: false,
        };
      else
        return {
          Tab1: validation.tabValidation.some((x) => x.id == 'Tab1' && x.value),
          Tab2: validation.tabValidation.some((x) => x.id == 'Tab2' && x.value),
          Tab3: validation.tabValidation.some((x) => x.id == 'Tab3' && x.value),
          Tab4: validation.tabValidation.some((x) => x.id == 'Tab4' && x.value),
          Tab5: validation.tabValidation.some((x) => x.id == 'Tab5' && x.value),
          Tab6: validation.tabValidation.some((x) => x.id == 'Tab6' && x.value),
          Tab7: validation.tabValidation.some((x) => x.id == 'Tab7' && x.value),
          Tab8: validation.tabValidation.some((x) => x.id == 'Tab8' && x.value),
          Tab9: validation.tabValidation.some((x) => x.id == 'Tab9' && x.value),
          Tab11:
            this.peiQuantity > 1 &&
            validation.tabValidation.some((x) => x.id == 'Tab11' && x.value),
        };
    },
    isMobile() {
      return store.getters.getIsMobileDensity;
    },
    isAiAssistantDocked() {
      return store.getters.getIsAiAssistantDocked;
    },
    // El Asistente IA anclado (440px) angosta el contenido tanto como una pantalla
    // móvil aunque isMobile (basado en el ancho crudo de la ventana) siga en false --
    // reusa el mismo CompactMenu de móvil para evitar que las pestañas se partan.
    // tabsOverflow cubre el resto de los casos (escritorio ancho pero con
    // demasiadas pestañas visibles, sidebar principal expandido, etc.): se
    // mide el ancho real disponible en vez de asumirlo por isMobile/isAiAssistantDocked.
    showCompactTabs() {
      return this.isMobile || this.isAiAssistantDocked || this.tabsOverflow;
    },
    selectedPeiStatus() {
      return store.getters.SelectedPeiStatus;
    },
    isPeiSigned() {
      return (
        this.selectedPeiStatus == peiStatuses.Firmado ||
        this.selectedPeiStatus == peiStatuses.PartialSignedPendingFunds ||
        this.selectedPeiStatus == peiStatuses.SignedWithControversy
      );
    },
    discussedPendingSignatures() {
      return (
        this.selectedPeiStatus == peiStatuses.Firmado ||
        this.selectedPeiStatus == peiStatuses.PartialSignedPendingFunds ||
        this.selectedPeiStatus == peiStatuses.CompletedWithPendingFunds
      );
    },
    showSignaturesTab() {
      const visibleStatuses = [
        +peiStatuses.Completado,
        +peiStatuses.Firmado,
        +peiStatuses.CompletedWithPendingFunds,
        +peiStatuses.PartialSignedPendingFunds,
      ];

      return (
        ((visibleStatuses.includes(+this.peiStatus) && !this.isPs) ||
          (this.isPs && this.discussedPendingSignatures)) &&
        this.signatureTabIsEnable
      );
    },
  },
  methods: {
    async initSignatureFlags() {
      const { data } = await getSysparameterByNames({
        academicYearId: store.getters.getConfigAcademicYearId,
        parameterNames: [
          PARAM_IsEnablePeiSignaturePeiSignedFiles,
          PARAM_IsEnablePeiSignatureCompuFiles,
        ],
      });

      store.commit(
        'setFlagSignatureCompu',
        data
          .find((x) => x.name == PARAM_IsEnablePeiSignatureCompuFiles)
          ?.staticValue?.toLowerCase() === 'true' ?? false
      );

      store.commit(
        'setFlagSignaturePei',
        data
          .find((x) => x.name == PARAM_IsEnablePeiSignaturePeiSignedFiles)
          ?.staticValue?.toLowerCase() === 'true' ?? false
      );

      const { data: responseData } = await getSysparameterByNames({
        parameterNames: [PARAM_ActiveEducationalCompensatoryService],
      });

      this.activeEducationalCompensatoryService =
        responseData
          .find((x) => x.name == PARAM_ActiveEducationalCompensatoryService)
          ?.staticValue?.toLowerCase() === 'true' ?? false;

      store.commit(
        'setFlagActiveEducationalCompensatoryService',
        this.activeEducationalCompensatoryService
      );
    },
    verifyPreviousPath() {
      if (this.previousPath?.name == PATH_NAME_ADD_EVALUATION) {
        this.activeTab = TAB2_ID;
      }
    },
    async getSignatureTabIsEnable() {
      const { data } = await signatures.getSignatureTabIsEnabled();
      store.commit('setTab10IsEnabled', data);
      this.signatureTabIsEnable = store.getters.getPeiInfo.tab10IsEnabled;
    },
    isActive(menuItem) {
      return this.activeTab === menuItem;
    },
    async setActive(menuItem) {
      // task:111236 - desde el tab 1 no existe la funcion guardar por tal motivo se debe permitir cambiar de tab sin guardar
      const bypassTab1 =
        this.activeTab === 'Tab1' && this.peiStatus == peiStatuses.Borrador;
      const canLeavePage =
        this.isPeiSigned || bypassTab1
          ? true
          : await store.dispatch('canLeavePage');

      if (!canLeavePage) return;

      store.commit('setFormDirty', { value: false });
      this.activeTab = menuItem;
    },
    checkVisibility(tab) {
      return tab.isVisible;
    },
    visibleTabs(tabs) {
      this.setTabsVisibility();
      const visible = tabs.filter(this.checkVisibility);
      // El conjunto de pestañas visibles puede cambiar en runtime (isPs,
      // isPsc, servicios compensatorios, firma...) -- re-chequear si siguen
      // cabiendo cada vez que se recalcula, no solo cuando cambia el ancho.
      this.$nextTick(this.checkTabsOverflow);
      return visible;
    },
    observeTabsWidth() {
      if (!window.ResizeObserver || !this.$refs.subMenuEl) return;
      this._tabsResizeObserver = new ResizeObserver(() => {
        this.$nextTick(this.checkTabsOverflow);
      });
      this._tabsResizeObserver.observe(this.$refs.subMenuEl);
    },
    checkTabsOverflow() {
      const ul = this.$refs.tabListEl;
      if (!ul || !ul.children.length) {
        this.tabsOverflow = false;
        return;
      }
      const rowHeight = ul.children[0].offsetHeight;
      if (!rowHeight) return;
      // .tab-list es nav-pills (flex-wrap:wrap): si las pestañas no caben en
      // el ancho disponible, el navegador ya las manda a una segunda fila --
      // scrollHeight refleja esa altura real aunque el <ul> esté oculto vía
      // .tabs-measure-only (height:0 + overflow:hidden en el padre no afecta
      // el scrollHeight propio del <ul>, que sigue reportando su contenido
      // completo). Se compara contra la altura de una sola fila con margen
      // de tolerancia por redondeo de línea.
      this.tabsOverflow = ul.scrollHeight > rowHeight * 1.5;
    },
    setTabsVisibility() {
      let locationRejected = store.getters.SelectedPeiLocationRejected;
      this.isPs = store.getters.getIsPs;
      this.isPsc = store.getters.getIsPsc;
      this.peiStatus = store.getters.SelectedPeiStatus;

      this.tabs.forEach((tab) => {
        if (tab.Id == 'Tab1' || tab.Id == 'Tab4' || tab.Id == 'Tab8') {
          tab.isVisible = true;
        } else {
          tab.isVisible =
            locationRejected == '1' &&
            this.peiStatus != peiStatuses.CompletedWithPendingFunds
              ? false
              : true;
        }
        if (
          this.isPsc &&
          (tab.Id == 'Tab2' ||
            tab.Id == 'Tab3' ||
            tab.Id == 'Tab5' ||
            tab.Id == 'Tab7')
        ) {
          tab.isVisible = false;
        }

        if (
          this.isPs &&
          (tab.Id == 'Tab5' || tab.Id == 'Tab6' || tab.Id == 'Tab7')
        ) {
          tab.isVisible = false;
        } else if (this.isPs && tab.Id == 'Tab8') {
          tab.Caption = 'VI-VII';
          tab.title = tab.tooltip =
            ' VI. Otras consideraciones y servicios / VII. Análisis ';
        } else if (locationRejected && tab.Id == 'Tab8') {
          tab.Caption = 'VIII';
          tab.title = tab.tooltip = 'Información del Estudiante';
        } else if (this.isPs && tab.Id == 'Tab9') {
          tab.Caption = 'VIII-X';
          tab.title = tab.tooltip =
            'VIII. Describa la manera en que se informará a los padres sobre el progreso del estudiante /  IX. Fecha de revisión del PEI / X. Firma de los miembros del Comité de Programación y Ubicación';
        } else if (tab.Id === 'Tab10') {
          tab.isVisible = this.showSignaturesTab;
        } else if (tab.Id === 'Tab11') {
          tab.isVisible =
            this.activeEducationalCompensatoryService && this.peiQuantity > 1;
        }
      });
    },
    async saveTab(deferred) {
      if (this.currentTabHeaderInfo.tabIndex == 9) {
        let child = this.$refs.currenTab;
        child.handleSubmit();
      }
      try {
        if (this.currentTabHeaderInfo.tabIndex == 10) {
          let child = this.$refs.currenTab;
          await child.handleSubmit();
        }
        if (this.currentTabHeaderInfo.tabIndex == 11) {
          let child = this.$refs.currenTab;
          await child.handleSubmit();
        }
        deferred?.resolve?.();
      } catch (error) {
        deferred?.reject?.(error);
        throw error;
      }
    },
    async refreshDigitalSignature(event = true) {
      if (this.currentTabHeaderInfo.tabIndex == 10) {
        let child = this.$refs.currenTab;
        await child.getDocumentSignature(event);
      }
    },
    updateImpedimentInfo(response) {
      if (this.currentTabHeaderInfo.tabIndex == 3) {
        let child = this.$refs.currenTab;
        child.updateImpedimentInfo(response);
      }
    },
    reRender() {
      this.$emit('reRender');
    },
    async setCompactActiveTab(menuItem) {
      const { Id: tabId } = menuItem;
      if (tabId) {
        const canLeavePage = await store.dispatch('canLeavePage');
        if (!canLeavePage) return;

        store.commit('setFormDirty', { value: false });
        this.activeTab = tabId;
      }
    },
    async getPeiQuantity() {
      const { data } = await generalService.getPeiQuantity(
        Number(store.getters.SelectedStudent.studentId)
      );
      this.peiQuantity = data;
      const tab11Index = this.tabs.findIndex((tab) => tab.Id === 'Tab11');
      if (tab11Index !== -1 && this.peiQuantity <= 1) {
        this.tabs.splice(tab11Index, 1);
      }
    },
    handleQueryParams(query = null) {
      const currentQuery = query || this.$root.$route.query;
      const isDraft = this.peiStatus == peiStatuses.Borrador;
      // Si hay un tab en los query params, cambiar el tab activo
      if (currentQuery.tab && currentQuery.tab !== this.activeTab) {
        // Solo cambiar el tab si no hay validación pendiente
        const bypassTab1 = this.activeTab === 'Tab1' && isDraft;
        const canChangeTab = this.isPeiSigned || bypassTab1;
        if (canChangeTab) {
          this.activeTab = currentQuery.tab;
        }
      } else if (
        isDraft &&
        // from tab 8
        this.activeTab === 'Tab8' &&
        // to tab 6
        currentQuery?.tab === 'Tab6'
      ) {
        this.activeTab = currentQuery?.tab;
      }

      // Si hay section y questionId, comunicarse con el tab activo
      if (currentQuery.section && currentQuery.questionId) {
        this.$nextTick(() => {
          // Emitir evento al tab activo para que maneje la navegación interna
          const currentTabComponent = this.$refs.currenTab;
          if (
            currentTabComponent &&
            typeof currentTabComponent.navigateToSection === 'function'
          ) {
            currentTabComponent.navigateToSection({
              section: currentQuery.section,
              questionId: currentQuery.questionId,
            });
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.nav {
  padding-left: 0px;
  margin-right: -11px;
}

.nav-item-Sub-menups {
  width: 14.15%;
  height: 55px;
}
a i.fas.fa-exclamation-triangle {
  color: #ff5b5c;
}
a.active i.fas.fa-exclamation-triangle {
  color: white;
}

.txt {
  padding-top: 8%;
  width: initial;
  line-height: 110%;
  white-space: pre-wrap;
}
.no-margin-bottom {
  margin-bottom: 0px;
}

.no-margin-left {
  margin-left: 0px !important;
}

.compensatory-tab {
  width: 200px !important;
}

.nav-item-Sub-menu-alt {
  width: 8.64%;
}

/* Cuando showCompactTabs es true por tabsOverflow (ver checkTabsOverflow),
   la fila completa de pestañas se sigue renderizando (no se desmonta con
   v-if) para poder seguir midiendo si ya volvería a caber, pero se oculta
   y no ocupa espacio: visibility:hidden + height:0 la saca del flujo visual
   sin afectar el layout de ancho (por eso el flex-wrap sigue calculándose
   igual) ni el scrollHeight que usa checkTabsOverflow. */
.tabs-measure-only {
  visibility: hidden;
  height: 0;
  overflow: hidden;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
